import { Box } from '@mui/material';

import AppiumConnection from '../appium/AppiumConnection';
import { SelectDeviceForAppiumAutomation } from './SelectDeviceForAppiumAutomation';
import { SelectAppBuildForAppiumAutomation } from './SelectAppBuildForAppiumAutomation';
import { API_ENDPOINTS } from '../../config/apiConfig';
import axiosInstance from '../../services/authService';

export function AppiumAutomationPagesHeader() {
  return (
    <Box display="flex" alignItems="center" justifyContent="flex-end" mb={2}>
      <Box display="flex" alignItems="center" gap={2}>
        <AppiumConnection />
        <SelectDeviceForAppiumAutomation />
        <SelectAppBuildForAppiumAutomation />
      </Box>
    </Box>
  );
}
